export const isObjectEmpty = (object) => {
  if (object instanceof Object) return Object.keys(object).length === 0;
  else return false;
};
